import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { segmentKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useSegmentAttributes = () => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryFn: () => axios.get(markUrl('segments/attributes/'), {
            ...additional
        }),
        queryKey: segmentKeys.attributes(),
        staleTime: 300_000
    });
};
export default useSegmentAttributes;
